// src/store/slices/dashboardSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  overviewData: {
    todaySales: 0,
    todayAppointments: 0,
    todayExpenses: 0,
    todayClientsVisited: 0,
  },
  appointments: [],
  overviewLoading: false,
  appointmentLoading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setOverviewData(state, action) {
      state.overviewData = action.payload;
    },
    setAppointmentsData(state, action) {
      state.appointments = action.payload;
    },
    setOverviewLoading(state, action) {
      state.overviewLoading = action.payload;
    },
    setAppointmentLoading(state, action) {
      state.appointmentLoading = action.payload;
    },
    resetDashboardData(state) {
      state.overviewData = initialState.overviewData;
      state.appointments = initialState.appointments;
    },
    completeAppointment: (state, action) => {
        const { appointmentId } = action.payload;
        
        // 1. Remove the completed appointment from the list
        state.appointments = state.appointments.filter(
          appointment => appointment._id !== appointmentId
        );
        
        // 2. Update overview counts
        state.overviewData.todayClientsVisited += 1;
        state.overviewData.todayAppointments = state.appointments.length;
        
        // You can add other overview updates if needed
      },
       updateAppointmentInState: (state, action) => {
    const { id, dateOfAppointment, timeOfAppointment, serviceSelected } = action.payload;
    const idx = state.appointments.findIndex((a) => a._id === id);
    if (idx !== -1) {
      state.appointments[idx] = {
        ...state.appointments[idx],
        dateOfAppointment,
        timeOfAppointment,
        serviceSelected,
      };
    }
  },
      
      // Add this to handle initial data fetching
      setDashboardData: (state, action) => {
        const { appointments, overviewData } = action.payload;
        state.appointments = appointments;
        state.overviewData = overviewData;
      } 
  },
});


export const {
  setOverviewData,
  setAppointmentsData,
  setOverviewLoading,
  setAppointmentLoading,
  resetDashboardData,
  completeAppointment,
  setDashboardData,
  updateAppointmentInState,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;